export default () => ({
  industrys: {
    1: '製造業',
    2: '情報通信・メディア',
    3: '小売・卸',
    4: '建設・不動産',
    5: '飲食・娯楽・エンターテイメント',
    6: '自動車・航空機産業',
    7: '運輸・物流',
    8: 'エレクトロニクス機器',
    9: '資源・エネルギー・素材',
    10: '金融',
    11: '生活・公共サービス',
    12: 'その他'
  },
  numberOfEmployees: {
    1: '1名以上〜30名以下',
    2: '31名以上〜50名以下',
    3: '51名以上〜100名以下',
    4: '101名以上～',
  },
  occupations: {
    1: '人事',
    2: '労務',
    3: '総務',
    4: '情報システム',
    5: '経営企画',
    6: '会社役員',
    7: '経理',
    8: '営業・マーケティング',
    9: '社労士',
    10: '税理士',
    11: 'その他',
  },
  reasons: {
    1: 'チラシ',
    2: 'SNS',
    3: 'インターネット',
    4: 'メールマガジン',
    5: '家族・友人の紹介',
    6: '企業の公式サイト',
    7: 'その他'
  }

});